import { createSlice } from "@reduxjs/toolkit";
import { getCreditsByPlanHandler, getUserProfileHandler, setAppliedSelectAllHandler, setRedirectionIdsArray, setUserDataHandler, setUserTokenDetailsHandler } from "./userDetails.action";

const initialState = {
  creditDetails: {},
  userData: {},
  userToken: {},
  redirectionIdsArr: [],
  appliedSelectAll: {
    import: false,
    export: false,
  },
};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: { ...initialState },
  reducers: {
    userTokenDetailsHandler: setUserTokenDetailsHandler,
    clearuserDetailsHandler: (state) => {
      state.creditDetails = { ...initialState.creditDetails };
      state.userData = { ...initialState.userData };
      state.userToken = { ...initialState.userToken };
    },
    userDataHandler: setUserDataHandler,
    appliedSelectAllHandler: setAppliedSelectAllHandler,
    setRedirectionIdsArrayHandler: setRedirectionIdsArray,
  },
  extraReducers: (builder) => {
    builder.addCase(getCreditsByPlanHandler.fulfilled, (state, action) => {
      state.creditDetails = { ...action.payload };
    });
    builder.addCase(getUserProfileHandler.fulfilled, (state, action) => {
      state.userData = { ...action.payload };
    });
  },
});

export const { userTokenDetailsHandler, clearuserDetailsHandler, appliedSelectAllHandler, setRedirectionIdsArrayHandler, userDataHandler } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
